import { Injectable } from "@angular/core";
import { Subject, BehaviorSubject } from "rxjs";

@Injectable()
export class SharedService {
  private loaderSource = new BehaviorSubject(false);
  public currentloader = this.loaderSource.asObservable();
  public isLoading: boolean;
  public isProjectsLoaded = false;
  // private dashboardReload: Subject<any> = new Subject<any>();
  //   public dashboardReloadListener() {
  //       return this.dashboardReload.asObservable();

  //   }
  //   public dashboardReloadObserver(value : any) {
  //       this.dashboardReload.next(value);
  //   }

  // showHideLoader(loading = true) {
  //     this.isLoading.next(true);
  // }
  // isLoading: boolean;
  // Loader(value = false) {
  //
  //     this.isLoading = value;
  // }
  changeLoader(load: boolean) {
    this.loaderSource.next(load);
  }
}
